const PATH = 'fe.components.dashboard.reminders';

const messages = {
  header: {
    key: `${PATH}.header`,
    defaultValue: 'Actions'
  },
  noActions: {
    key: `${PATH}.no_actions`,
    defaultValue: "Looks like you're all caught up"
  }
};

export default messages;
